export default __webpack_public_path__ + "static/media/screenhacker_03.2ee7914d.png";